import { ELockPhoto } from './types'

export const eLockPhotoTypeToTitle = {
  [ELockPhoto.doorFromInside]: 'Дверь изнутри',
  [ELockPhoto.doorFromTheEnd]: 'Дверь с торца',
  [ELockPhoto.controller]: 'Контроллер',
}
